<script setup>
import {computed, onMounted, ref} from "vue";
import store from "@/store";
import {game} from "@/utils/config";
import LoginComponents from "@/components/login/LoginComponents.vue";
import RealName from "@/components/login/RealName.vue";
import SendSmsComponents from "@/components/login/SendSmsComponents.vue";
import {useRoute} from "vue-router";
import {ElMessage} from "element-plus";
import axiosApi from "@/utils/axiosApi";
import router from "@/router";

const type = computed(() => {
  let _type = store.state.coupon
  if (_type) {
    const _d = game[_type]
    // document.title = _d.title
    return game[_type]
  }
  return {}
})
const coupon = computed(() => {
  const product = store.state.product
  document.title = product.goods_name
  return product
})
const account = computed(() => {
  return store.state.account
})
const success = ref(false)
const changeProduct = ref(false)
const showLogin = ref(false)
const rechargeAccount = ref("")
const payNumber = ref(1)
const showSend = ref(false)
const realDialog = ref(false)
const payLoading = ref(false)
const drawerPay = ({account: mobi, number}) => {
  rechargeAccount.value = mobi
  payNumber.value = number
  pay()
}

onMounted(() => {
  store.commit('getCoupon');
  store.commit("getProduct")
  store.dispatch("getAccounts")
})

const pay = async () => {
  if (rechargeAccount.value === "" || !rechargeAccount.value || rechargeAccount.value.length < 1) {
    return ElMessage.error("请输入充值账号")
  }
  if (!showSend.value) {
    showSend.value = true
    return
  }
  showSend.value = false
  payLoading.value = true
  new axiosApi({
    encode: "coupon",
    method: "life/pay",
    body: {
      plate: type.value.coupon,
      product: coupon.value.third_id,
      type: "scal",
      cust_id: account.value.cust_id,
      account: rechargeAccount.value,
      number: payNumber.value,
      access_token: account.value.access_token || "",
      user_id: account.value.user_id || ""
    }
  }).send(res => {
    payLoading.value = false
    if (res.message.code !== "000" && res.message.code !== '7401') return ElMessage.error(res.message.content)
    else if (res.message.code === '7401') {
      realDialog.value = true
      return
    }
    success.value = true
    changeProduct.value = false
    // coupon.value = {}
  }, () => payLoading.value = false)
}

const checkPay = () => {
  if (Object.keys(account.value).length < 1) {
    showLogin.value = true
    return
  }
  showLogin.value = false
  changeProduct.value = true
}
</script>

<template>
  <el-scrollbar class="product-detail">
    <el-image :src="coupon?.detail" class="product-detail-img"/>
  </el-scrollbar>
  <div class="pay-footer">
    <div class="pay-miles">
      <el-text type="danger" size="large">{{ coupon?.mileTypes?.scal?.total }}</el-text>
      <el-text type="info" size="small">{{ coupon?.mileTypes?.scal?.unit }}</el-text>
    </div>
    <div>
      <el-button round type="danger" @click="checkPay">立即兑换</el-button>
    </div>
  </div>
  <component :is="type.coupon+'_drawer'" :changeProduct="changeProduct" :product="coupon"
             :account="account" :payLoading="payLoading" @pay="drawerPay" v-if="changeProduct"
             @close="changeProduct=false"/>
  <login-components :show-login="showLogin" @login="checkPay" v-if="showLogin"/>
  <send-sms-components :show="showSend" @sends="pay" :login-account="account" v-if="showSend"/>
  <real-name :dialog="realDialog" @changeModel="realDialog=false" v-if="realDialog"/>
  <el-dialog v-model="success" :show-close="false" width="90%" class="success-dialog" style="border-radius: 12px"
             v-if="success" :style="type.style">
    <div class="success-image">
      <el-image :src="type.successImg"/>
      <div class="success-content">兑换成功</div>
    </div>
    <div class="success-btn">
      <div class="cancel-btn bts" @click="success=false">返回首页</div>
      <div class="order-btn bts" @click="router.replace({name:'order'})">查看订单</div>
    </div>
  </el-dialog>
</template>

<style scoped lang="less">
.product-detail {
  height: calc(100vh - 50px);
}

.pay-footer {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 15px;
}

.success-dialog {
  .success-image {
    margin: 15px auto;
    width: 140px;
    text-align: center;

    .success-content {
      margin-top: 10px;
      font-size: 1.25rem;
      font-weight: 600;
      color: var(--view-product-success-color);
    }
  }

  .success-btn {
    display: flex;
    align-items: center;
    justify-content: center;

    .bts {
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 8px;

      &.order-btn {
        margin-left: 10px;
        background: var(--view-product-success-btn-success-background);
        color: var(--view-product-success-btn-success-color);
      }

      &.cancel-btn {
        background: var(--view-product-success-btn-cancel-background);
        color: var(--view-product-success-btn-cancel-color);
      }
    }
  }
}
</style>
